import { render, staticRenderFns } from "./DialogConfirmationComponent.vue?vue&type=template&id=0699ec40"
import script from "./DialogConfirmationComponent.vue?vue&type=script&lang=js"
export * from "./DialogConfirmationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0699ec40')) {
      api.createRecord('0699ec40', component.options)
    } else {
      api.reload('0699ec40', component.options)
    }
    module.hot.accept("./DialogConfirmationComponent.vue?vue&type=template&id=0699ec40", function () {
      api.rerender('0699ec40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogConfirmationComponent.vue"
export default component.exports